<template>
    <b-form-group style="margin: 0">
        <b-form-group label="登录密码" label-align="right" label-cols="3" :label-size="size">
            <b-form-input v-model="form.newPassword" :size="size" :state="validationLength" type="password" placeholder="请输入6位以上密码"/>
            <b-form-invalid-feedback :state="validationLength">请输入6位以上密码</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="重复密码" label-align="right" label-cols="3" :label-size="size">
            <b-form-input v-model="form.repeatPassword" :state="validationSame" :size="size" type="password" placeholder="重复密码"/>
            <b-form-invalid-feedback :state="validationLength">两次输入密码不一致</b-form-invalid-feedback>
        </b-form-group>
    </b-form-group>
</template>

<script>
export default {
    name: "RepeatPassword",
    props: {
        size: {
            type: String,
            default: 'md'
        },
        form: Object,
        state: Boolean
    },
    data() {
        return {
        }
    },
    computed: {
        validationLength() {
            return this.form.newPassword.length >= 6;
        },
        validationSame() {
            return this.form.newPassword !== '' && this.form.newPassword === this.form.repeatPassword;
        },
        valid() {
            return this.validationLength && this.validationSame;
        }
    },
    watch: {
        valid(n) {
            this.$emit('update:state', n);
        }
    }
}
</script>

<style scoped>

</style>